import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ReceiptsList from './components/ReceiptsList';

const InvoiceCostumer = () => (
  <Container >
    <Row>
      <Col md={12}>
        <h3 style={{ marginBottom: 30 }}>Busqueda Recibos de Caja</h3>
      </Col>
    </Row>
    <Row>
        <ReceiptsList />
    </Row>
  </Container>
);

export default InvoiceCostumer;